/**
 * Extending the built in class loses stack traces, this provides an
 * Error class you can extend
 *
 * @see: http://stackoverflow.com/questions/30402287/extended-errors-do-not-have-message-or-stack-trace
 */

function ErrorClass(message, extra) {
    if (Error.hasOwnProperty('captureStackTrace')) {
        Error.captureStackTrace(this, this.constructor);
    } else {
        Object.defineProperty(this, 'stack', {
            value: (new Error()).stack
        });
    }

    if (message !== undefined) {
        Object.defineProperty(this, 'message', {
            value: message,
            writable: true
        });
    }

    this.extra = extra;
}

ErrorClass.prototype = Object.create(Error.prototype);
ErrorClass.prototype.constructor = ErrorClass;

export default ErrorClass;
